import React, { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useAppDispatch } from '../../../store/hooks';
import { queryParams } from "../../../helpers/UrlHelpers";
import { fetchPhnSubscriptionPlans } from "../../../actions/callrecorder/phnSubscriptionPlansActions";
import { setNewParams } from "../../../store/callrecorder/phnSubscriptionPlansSlice";

import PageLayout from '../_partials/PageLayout';
import Edit from "./Edit";
import New from "./New";
import ListTable from "./_partials/_ListTable";
import PricingPlansCards from "../AvailablePhoneNumbers/_partials/_PricingPlansCards";
import PageHeader from "../../../componets/PageHeader";
import Wrapper from "../../../componets/Wrapper";
import Filter from "../../../componets/Filter";
import NavBarThree from "../../../componets/NavBarThree";
import { PlusOutlined } from "@ant-design/icons";
import './style.scss';

const LIMIT = 42;

const PhnSubscriptionPlans = () => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const currentPage = queryParams.getInt(searchParams,'page') || 1;
  const { pathname } = useLocation();

  useEffect(() => {
    const params: any = queryParams.requestParams(
      searchParams,
      {
        limit:  LIMIT,
        offset: (currentPage - 1) * LIMIT
      },
      ['term', 'search_by', 'order_by', 'order', 'date_from', 'date_to']
    );

    dispatch(fetchPhnSubscriptionPlans(params));
  }, [searchParams, pathname, currentPage, dispatch]);

  function onClickCreate() {
    const params: any = { active: true };
    dispatch(setNewParams(params));
  }

  return (
    <PageLayout className='v-phn-subscription-plans'>
      <PageHeader title='Subscription Plans' />

      <Wrapper>
        <NavBarThree>
          <NavBarThree.Button className='v-link2' onClick={onClickCreate}>
            <PlusOutlined /> Create Plan
          </NavBarThree.Button>
        </NavBarThree>
      </Wrapper>

      <div className='v-container'>
        <Wrapper type='type-1' border className='v-mb-10'>
          <h6 className='v-content-label o-sm'>Preview Plans</h6>
          <PricingPlansCards uid="twilio:local:18254792054" />
        </Wrapper>

        <Wrapper type='type-1' border className='v-mb-10'>
          <Filter dateRange />
        </Wrapper>

        <ListTable limit={LIMIT} />
      </div>

      <New />
      <Edit />
    </PageLayout>
  );
}

export default PhnSubscriptionPlans;
